import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

// Logical area: AddressEditor UI Strings
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.webmodule-common.other.ui.address-editor.';

  public static readonly defaultShippingAddress = `${Id.prefix}defaultShippingAddress`;
  public static readonly sameAsPhysicalAddress = `${Id.prefix}sameAsPhysicalAddress`;
  public static readonly selectAddress = `${Id.prefix}selectAddress`;
  public static readonly lookup = `${Id.prefix}lookup`;
  public static readonly shippingNote = `${Id.prefix}shippingNote`;
  public static readonly streetAddress = `${Id.prefix}streetAddress`;
  public static readonly city = `${Id.prefix}city`;
  public static readonly state = `${Id.prefix}state`;
  public static readonly zipCode = `${Id.prefix}zipCode`;
  public static readonly country = `${Id.prefix}country`;
}

export class LangAddressEditor {
  private constructor() {}
  public static defaultShippingAddress(): string {
    return interpolate(Id.defaultShippingAddress);
  }
  public static sameAsPhysicalAddress(): string {
    return interpolate(Id.sameAsPhysicalAddress);
  }
  public static selectAddress(): string {
    return interpolate(Id.selectAddress);
  }
  public static lookup(): string {
    return interpolate(Id.lookup);
  }
  public static shippingNote(): string {
    // Glossary plural: {{glossary 'shipping-note:plural'}}
    return interpolate(Id.shippingNote);
  }
  public static streetAddress(): string {
    return interpolate(Id.streetAddress);
  }
  public static city(): string {
    return interpolate(Id.city);
  }
  public static state(): string {
    return interpolate(Id.state);
  }
  public static zipCode(): string {
    return interpolate(Id.zipCode);
  }
  public static country(): string {
    return interpolate(Id.country);
  }
}

export class AddressEditorModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    // AddressEditor UI Strings
    register.add(
      Id.defaultShippingAddress,
      'Default Shipping Address',
      'Label for the default shipping address toggle (part of an address)'
    );
    register.add(
      Id.sameAsPhysicalAddress,
      'Same as Physical Address',
      'Label for the radio group to copy physical address (part of an address)'
    );
    register.add(
      Id.selectAddress,
      'Select Address',
      'Label/title/placeholder for selecting an address (part of an address)'
    );
    register.add(Id.lookup, 'Lookup', 'Label for the address lookup field (part of an address)');
    register.add(
      Id.shippingNote,
      "{{glossary 'shipping-note:plural'}}",
      'Label for shipping note field (part of an address)'
    );
    register.add(Id.streetAddress, 'Street Address', 'Label for street address field (part of an address)');
    register.add(Id.city, 'City', 'Label for city field (part of an address)');
    register.add(Id.state, 'State', 'Label for state field (part of an address)');
    register.add(Id.zipCode, 'Zip Code', 'Label for zip code field (part of an address)');
    register.add(Id.country, 'Country', 'Label for country field (part of an address)');
  }
}
